module.exports = __webpack_public_path__ + "media/images/redesign-images/get-inspired/gi-pinterest-4-d9cbd6403483fa5dcc667918e5443ab7.jpg";